export const PROFILES_KEY = 'profiles'

export const PROFILE_REVIEWS_KEY = 'profileReviews'

export enum PROFILE_TYPE {
  COMPANY = 'profileCompany',
  SPECIALIST = 'profileSpecialist',
  FACTORY = 'profileFactory'
}

export const COMPANIES = 'companies'

export enum REVIEW_TYPE {
  BAD = 'BAD',
  GOOD = 'GOOD',
  NEUTRAL = 'NEUTRAL'
}

export const REVIEW_TYPE_VALUES = {
  [REVIEW_TYPE.GOOD]: 'Хорошие',
  [REVIEW_TYPE.NEUTRAL]: 'Нейтральные',
  [REVIEW_TYPE.BAD]: 'Плохие'
}
